import type { Website } from 'types';
import { useState } from 'react';
import { Target } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { ROW_ACTION_BUTTON } from '../../ConsolePanel';
import { EventGoalsConfig } from '../Details/EventGoalsConfig';

type EventGoalsModalProps = {
  website: Website;
  /** A product tour anchor for the trigger. */
  tourAnchor?: string;
};

export const EventGoalsModal = ({ website, tourAnchor }: EventGoalsModalProps) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        className={ROW_ACTION_BUTTON}
        data-tour={tourAnchor}
      >
        <Target className="mr-1 size-3.5" />
        Event Goals
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        {/*
          Header and footer never move; the mapping in between takes whatever is left and
          scrolls. A website with thousands of events used to stretch the dialog past the
          bottom of the screen and take Done with it, so the height is capped against the
          viewport and the overflow is handled inside, not by growing.
        */}
        <DialogContent className="flex max-h-[90vh] w-[95vw] max-w-none flex-col overflow-hidden sm:w-[80vw]">
          <DialogHeader className="shrink-0">
            <DialogTitle>Event Goals</DialogTitle>
            <DialogDescription>Configure which events are tracked for {website.url}.</DialogDescription>
          </DialogHeader>
          <EventGoalsConfig websiteId={website.id} />
          <DialogFooter className="shrink-0">
            <Button onClick={() => setOpen(false)} className="h-9 rounded-lg">
              Done
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
